import moment from 'moment'

export default {
  data() {
    return {
      /** Set true saat submit form (POST/PUT); pakai untuk disable button + loading */
      submitting: false,
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    formatDetailDate(date) {
      return moment(date).format('DD MMMM YYYY')
    },
    formatBirthDate(date) {
      return moment(date).format('DD-MM-YYYY')
    },
    formatBirthDateTime(datetime) {
      return moment(datetime).subtract(7, 'hours').format('DD/MM/YYYY H:mm:ss')
    },
    today() {
      return moment().format('YYYY-MM-DD')
    },
    startOfMonth() {
      return moment().startOf('month').format('YYYY-MM-DD')
    },
    checkValue(val) {
      if (!val || val === undefined || val === '') return false
      return true
    },
    onlyNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault()
      }
    },
    isNumberFormat(event) {
      const allowedKeys = [
        'Backspace',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        'Enter',
        'Home',
        'End',
      ]

      // Izinkan kombinasi Ctrl/Cmd (copy, paste, select all, dsb)
      if (event.ctrlKey || event.metaKey) return

      // Izinkan tombol kontrol & navigasi
      if (allowedKeys.includes(event.key)) return

      // Hanya izinkan angka 0-9
      if (/^[0-9]$/.test(event.key)) return

      // Selain itu, blok input
      event.preventDefault()
    },
    loadAlphabet() {
      const a = []
      let i = 'a'.charCodeAt(0)
      const j = 'z'.charCodeAt(0)
      for (; i <= j; ++i) {
        a.push(String.fromCharCode(i))
      }

      return a.map((v, i) => ({
        value: i + 1,
        text: v.toLocaleUpperCase(),
      }))
    },
    formatSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    getExtention(file) {
      return file.split('.').pop().toLowerCase()
    },
    /**
     * Ambil teks error dari response API (axios catch).
     * Backend bisa mengembalikan messages (array) atau message (string).
     * @param {object} err - Error object dari .catch((err) => ...)
     * @param {string} fallback - Teks fallback jika tidak ada message
     * @returns {string}
     */
    getApiErrorMessage(err, fallback = 'Terjadi kesalahan') {
      const data = err?.response?.data
      if (!data) return fallback
      if (Array.isArray(data.messages) && data.messages.length > 0) {
        return data.messages.map((m) => (typeof m === 'string' ? m : String(m))).join('\n')
      }
      if (data.message != null && data.message !== '') {
        return typeof data.message === 'string' ? data.message : String(data.message)
      }
      return fallback
    },
    /**
     * Jalankan async fn dengan state submitting (disable button + loading).
     * Set submitting = true sebelum fn, false di finally.
     * @param {Function} fn - async function yang berisi axios post/put
     * @returns {Promise}
     */
    async withSubmitting(fn) {
      this.submitting = true
      try {
        return await fn()
      } finally {
        this.submitting = false
      }
    },
  },
}
